import { Button } from '@material-ui/core';
import CustomPopupModel from '../custom-popup/Custom-Popup';
import { handleCancel, handleSave } from './dragDrop';

export const SaveButton = ({
  visible,
  setVisible,
  popUp,
  setPopUp,
  placeHolder,
  setPlaceHolder,
  globalPlaceHolder,
  setGlobalPlaceHolder,
  globalCategoryPlaceHolder,
  globalRoomTypePlaceHolder,
  dispatch,
  mappingApi,
  displayText,
  module,
  nestedStatus,
  setNestedStatus,
  setExpanded,
  setDrag,
}) => {
  return (
    <>
      {' '}
      {visible ? (
        <Button
          onClick={() => {
            handleSave(
              dispatch,
              setGlobalPlaceHolder,
              placeHolder,
              mappingApi,
              setPopUp,
              setVisible,
              setPlaceHolder,
              globalPlaceHolder,
              displayText,
              globalCategoryPlaceHolder,
              globalRoomTypePlaceHolder,
              module,
              nestedStatus,
              setNestedStatus,
              setExpanded,
            );
            document.body.classList.remove('popup-active');
          }}
          variant='contained'
          color='secondary'
          className='me-4'
          size='large'
        >
          Save
        </Button>
      ) : null}
      <CustomPopupModel
        popUp={{
          status: Boolean(popUp),
          title: 'Do you want to save the changes?',
          buttonName: 'Save',
          cancel: 'Cancel',
        }}
        style={{
          paddingLeft: '2rem',
          paddingRight: '2rem',
        }}
        onClickCancel={() =>
          handleCancel(
            setPopUp,
            setVisible,
            setPlaceHolder,
            globalPlaceHolder,
            globalCategoryPlaceHolder,
            globalRoomTypePlaceHolder,
            displayText,
            setExpanded,
            setDrag,
            module,
            dispatch,
            placeHolder,
          )
        }
        onClick={() =>
          handleSave(
            dispatch,
            setGlobalPlaceHolder,
            placeHolder,
            mappingApi,
            setPopUp,
            setVisible,
            setPlaceHolder,
            globalPlaceHolder,
            displayText,
            globalCategoryPlaceHolder,
            globalRoomTypePlaceHolder,
            module,
            nestedStatus,
            setNestedStatus,
            setExpanded,
          )
        }
      />
    </>
  );
};
